module.exports = __webpack_public_path__ + "img/Grupprnbildersatz.3984e8db.jpg";